export const SWIPER_BREAKPOINTS = {
  dots: false,
  vertical: true,
  verticalSwiping: true,
  swipeToSlide: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  speed: 500
};

export const YEAR_INTERVAL = 100;

export const BOTTOM_LONG_ARROW_URL = '/image/bottom_long_arrow.svg';
